import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "../components/ui/accordion";

const FAQS = [
  { q: "When will my recovery system arrive?", a: "We aim to have your system in hand 3–5 days before surgery. Enter your date at checkout or use the Procedure Finder." },
  { q: "Which procedures are covered?", a: "Liposuction, Breast Augmentation, Tummy Tuck, Mommy Makeover, Facelift, and Injectables & Laser Resurfacing." },
  { q: "Is ALTA medical grade?", a: "Yes. Every component is vetted with board-certified plastic surgeons and sourced from medical-grade suppliers. ALTA products are aftercare accessories, not medical devices." },
  { q: "How does shipping work?", a: "Free shipping across the US, Canada, UK and Australia. Signature is not required and packaging is discreet." },
  { q: "Can I return unused products?", a: "Unopened systems can be returned within 14 days. Opened items are non-returnable for hygiene reasons." },
  { q: "What if my surgery is rescheduled?", a: "Email support@altarecovery.com and we'll re-schedule delivery to align with your new date." },
  { q: "Do you offer clinic / bulk pricing?", a: "Yes — we work directly with clinics who order patient-specific systems. Contact us for our surgeon program." },
];

export default function FaqPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
      <div className="eyebrow">Answers</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight">Frequently Asked Questions</h1>
      <Accordion type="single" collapsible className="mt-12">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E5CDBB]">
            <AccordionTrigger className="font-serif text-lg text-left hover:no-underline py-6">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#6B5757] pb-6 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-16 border border-[#F0DFD0] p-8 bg-[#FDF3ED]">
        <h3 className="font-serif text-2xl">Medical Disclaimer</h3>
        <p className="text-sm text-[#6B5757] mt-3 leading-relaxed">
          ALTA Recovery products are aftercare accessories — they are not medical devices and do not diagnose,
          treat, cure or prevent any disease. Always follow the specific instructions given by your surgeon and
          medical team. If you experience unusual pain, bleeding, or signs of infection, contact your surgeon immediately.
        </p>
      </div>
    </div>
  );
}
